import loadable from '@loadable/component';

import { IRoute } from '../interfaces/routing';

const NotFound = loadable(() => import ('../pages/sessions/404'));
const InternalError = loadable(() => import ('../pages/sessions/500'));
const AdminSign = loadable(() => import ('../pages/sessions/AdminSign-in'));
const ClientSignUp = loadable(() => import ('../pages/sessions/Client-Sign-up'));
const ConsultantSign = loadable(() => import ('../pages/sessions/ConsultantSign-in'));
const SignIn = loadable(() => import ('../pages/sessions/Sign-in'));
const SignUp = loadable(() => import ('../pages/sessions/ConsultantSign-up'));
const ForgetPasswordPage = loadable(() => import ('../pages/sessions/Client/ForgetPasswordPage'));
const ResetPasswordPage = loadable(() => import ('../pages/sessions/Client/ResetPasswordPage'));
const ForgetPasswordPage2 = loadable(() => import ('../pages/sessions/Consultant/ForgetPasswordPage'));
const ResetPasswordPage2 = loadable(() => import ('../pages/sessions/Consultant/ResetPasswordPage'));
const ForgetPasswordPage3 = loadable(() => import ('../pages/sessions/Admin/ForgetPasswordPage'));
const ResetPasswordPage3 = loadable(() => import ('../pages/sessions/Admin/ResetPasswordPage'));
const ClientSignInn = loadable(() => import ('../pages/sessions/ClientSignInn'));

export const sessionRoutes: IRoute[] = [
    {
        path: 'page-404',
        component: NotFound
    },
    {
        path: 'page-500',
        component: InternalError
    },
    {
        path: 'sign-in',
        component: SignIn
    },
    {
        path: 'admin/sign-in',
        component: AdminSign
    },
    {
        path: 'admin/forget-password',
        component: ForgetPasswordPage3
    },
    {
        path: 'admin/verify/:reset_password_token/:email',
        component: ResetPasswordPage3
    },
    {
        path: 'client/sign-up',
        component: ClientSignUp
    },
    {
        path: 'client/sign-in',
        component: ClientSignInn
    },
    {
        path: 'client/forget-password',
        component: ForgetPasswordPage
    },
    {
        path: 'client/verify/:reset_password_token/:email',
        component: ResetPasswordPage
    },


    {
        path: 'sign-up',
        component: SignUp
    },
    {
        path: 'consultant/sign-in',
        component: ConsultantSign
    },
    {
        path: 'consultant/sign-up',
        component: SignUp
    },
    {
        path: 'consultant/forget-password',
        component: ForgetPasswordPage2
    },
    {
        path: 'consultant/verify/:reset_password_token/:email',
        component: ResetPasswordPage2
    }
];
